import React from 'react';
import {compose} from 'redux';
import {withRouter} from 'react-router-dom';
import {withTranslationsAsProps} from '../../../components/translations';

export function FavoritesMessage({isShared, langList, langListShared, location}) {
    const isFavoritesRedirect = location && location.search && location.search.indexOf('redirect=favorites') !== -1;
    if (!isFavoritesRedirect) {
        return null;
    }
    return (
        <div>
            <div className="fade in alert alert--verbose alert-info" role="alert">
                <svg className="inline-svg" aria-hidden="true">
                    <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="#svg-clock" />
                </svg>
                <div className="scratchpad-alert-message-text">
                    <p>{isShared ? langListShared : langList}</p>
                </div>
            </div>
        </div>
    );
}

export default compose(withTranslationsAsProps({
    'tripboards.favorites.list': 'langList',
    'tripboards.favorites.shared_list': 'langListShared'
}),
withRouter)(FavoritesMessage);



// WEBPACK FOOTER //
// ./src/universal/tripboard/details/components/favorites-message.js